import DEV_IMG from  "../../dev-image.png"
const About = () => {
  return (
    <div className="p-5">
      <h2 className="text-3xl mt-10 ">Intro</h2>
      <div className="border-t-2 w-[5%] border-solid border-neutral-400  h-2  mb-10 "></div>

    <p className="text-xl px-2 text-justify">
      I am a Web Developer specializing in FrontEnd development, proficient in crafting applications that adhere to industry best practices and standards. Holding a Bachelor's degree in Computer Science and Engineering, I am committed to staying updated with the latest advancements in both technology and science. Outside of my professional endeavors, I am an avid reader, gamer, and technology enthusiast, consistently exploring and embracing new innovations.
      </p>
    </div>
  );
};

export default About;
